var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Transcript",style:({
  'background': _vm.transcriptSettings.background,
  'color': _vm.transcriptSettings.color,
  'font-size': _vm.transcriptSettings.size + 'pt',
  'justify-content': _vm.transcriptSettings.justify
  }),on:{"click":_vm.exitFullscreen}},_vm._l((_vm.transcript),function(userMessage,key){return _c('div',{key:key},[_c('div',[_c('UserMessage',{attrs:{"userMessage":userMessage}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }